import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useState,
} from 'react';

import { TableObjectModel } from '../../../../models/table-object.model';

export interface SetIsCheckedContextModel {
  checked: TableObjectModel<boolean>;
  setIsChecked: Dispatch<SetStateAction<TableObjectModel<boolean>>>;
}

export const SetIsCheckedContext = createContext<
  SetIsCheckedContextModel | undefined
>(undefined);

const SetIsCheckedContextProvider: FC<
  PropsWithChildren<Record<string, unknown>>
> = props => {
  const [checked, setIsChecked] = useState<TableObjectModel<boolean>>({});

  return (
    <SetIsCheckedContext.Provider value={{ checked, setIsChecked }}>
      {props.children}
    </SetIsCheckedContext.Provider>
  );
};

export default SetIsCheckedContextProvider;
